import {ZIDX} from "../standaloneLibrary.js";
import jQuery from "jquery";

let $=jQuery.noConflict();
const STORAGE_KEY = "zidx_listing_views";
const MIN_HUMAN_SIGNAL_MS = 3000; // must be on page at least 3s
const VIEW_EXPIRY_DAYS = 1;      // reset the counter after 30 days

interface ViewRecord {
    count: number;
    firstSeen: number; // unix ms
}

export class ListingViewGate {
    private zidx: ZIDX;
    private humanSignalFired = false;
    private pageLoadTime = Date.now();
    // private listingId: string;
    private cleanupFns: (() => void)[] = [];

    constructor(zidx: ZIDX){//}, listingId: string) {
        this.zidx = zidx;
        // this.listingId = listingId;
        this.init();
    }

    /** Call once in ZIDXListingDetail.render() */
    init() {
        // Already logged in (non-guest) — no gating needed
        if (this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) return;

        const onSignal = () => this.handleHumanSignal();
        const events = ["mousemove", "scroll", "touchstart", "keydown"] as const;

        events.forEach(evt => {
            window.addEventListener(evt, onSignal, { passive: true, once: false });
            this.cleanupFns.push(() => window.removeEventListener(evt, onSignal));
        });
    }

    private handleHumanSignal() {
        if (this.humanSignalFired) return;
        if(this.zidx.options.registerListingViewLimit==0 || this.zidx.options.registerListingMode==0){
            return; // no limit, no gating
        }
        if (this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) {
            localStorage.removeItem(STORAGE_KEY); // no limit, no gating
            return;
        }

        const elapsed = Date.now() - this.pageLoadTime;
        if (elapsed < MIN_HUMAN_SIGNAL_MS) {
            // Too fast — reschedule check after remaining time
            setTimeout(() => this.handleHumanSignal(), MIN_HUMAN_SIGNAL_MS - elapsed);
            return;
        }

        this.humanSignalFired = true;
        this.cleanupFns.forEach(fn => fn()); // remove all listeners
        const count = this.incrementViewCount();
        if (count >= this.zidx.options.registerListingViewLimit) {
            this.showLoginForm();
        }
    }
    showLoginForm(){
        let disableClose = false;
        if(this.zidx.options.registerListingMode==2){
            disableClose=true;
        }
        let width = 0;
        let height = 0;
        if ($(window).width()! < 992) {
            width = Math.min(600, $(window).width()! - 20);
            height = Math.min(500, $(window).height()! - 20);
        } else {
            width = Math.min(800, $(window).width()! - 50);
            height = Math.min(600, $(window).height()! - 50);
        }
        let url=new URL(window.location.href);
        let loginURL=this.zidx.options.siteDomain+"/login/?redirectURL="+encodeURIComponent(url.pathname + url.search)+"&forced=1&embedded=1&ztv="+Math.random();
        var modalContent1='<iframe id="zModalIframeLogin" src="'+loginURL+'" scrolling="yes" frameborder="0"  style=" margin:0px; border:none; overflow:auto; -webkit-overflow-scrolling: touch; position:relative; " seamless="seamless" width="100%" height="98%" />';
        this.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,

            "disableClose":disableClose,
            "fullscreen":false});
    }

    private getStoredViews(): ViewRecord | null {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            const record: ViewRecord = JSON.parse(raw);
            // Expire old records
            const ageMs = Date.now() - record.firstSeen;
            if (ageMs > VIEW_EXPIRY_DAYS * 86400 * 1000) {
                localStorage.removeItem(STORAGE_KEY);
                return null;
            }
            return record;
        } catch {
            return null;
        }
    }

    private incrementViewCount(): number {
        const existing = this.getStoredViews();
        const record: ViewRecord = existing ?? { count: 0, firstSeen: Date.now() };
        record.count += 1;
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
        } catch {
            // localStorage full or blocked — degrade gracefully
        }
        return record.count;
    }

    /** Optional: call after successful login to reset the counter */
    static resetViews() {
        localStorage.removeItem(STORAGE_KEY);
    }
}